<template>
    <div>
      <div v-if="!isEdit" class="title is-3">Create new pack</div>
      <div v-if="isEdit" class="title is-3">Edit this pack</div>

      <form>
        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label">Name:</label>
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control">
                <input v-model="name" class="input" type="text" placeholder="Pack name">
                        </div>
                    </div>
                </div>
            </div>

            <div class="field is-horizontal">
                <div class="field-label is-normal">
                    <label class="label">Description:</label>
                </div>
                <div class="field-body">
                    <div class="field">
                        <div class="control">
                            <input v-model="description" class="input" type="text"
                                   placeholder="Describe the pack for newbies">
                        </div>
                    </div>
                </div>
            </div>

            <div class="field is-horizontal">
                <div class="field-label is-normal">
                    <label class="label">Suitable for:</label>
                </div>
                <div class="field-body">
                    <div class="field">
                        <div class="control">
                            <b-field>
                                <b-checkbox-button v-model="suitableFor"
                                                   v-for="(age, index) in ages"
                                                   :key="index"
                                                   :native-value="age"
                                                   type="is-info"
                                                   style="padding-right: 4px">
                                    <b-icon icon="check"></b-icon>
                                    <span>{{ age }}</span>
                                </b-checkbox-button>
                            </b-field>
                        </div>
                    </div>
                </div>
            </div>

            <div class="field is-horizontal">
                <div class="field-label is-normal">
                    <label class="label">Tags:</label>
                </div>
                <div class="field-body">
                    <div class="field">
                        <div class="control">
                            <b-taginput
                                    v-model="tags"
                                    :allow-new="true"
                                    icon="label"
                                    ellipsis
                                    type="is-warning"
                                    placeholder="Add a tag">
                            </b-taginput>
                        </div>
                    </div>
                </div>
            </div>

            <div class="control submit">
                <button
                        class="button is-light btn-margin"
                        @click.prevent="cancel()"
                >
                    Back to packs
                </button>
                <button @click.prevent="createPack" class="button is-primary" v-if="!isEdit">Create pack</button>
                <button @click.prevent="updatePack" class="button is-primary" v-if="isEdit">Update pack</button>
            </div>
        </form>
        <b-loading :is-full-page="true" :active.sync="isLoading"></b-loading>
    </div>
</template>

<script>
  import packService from '../../services/packService'
  import displayHelper from '../../helpers/display-helper'
  import dateHelper from '../../helpers/date-helper'
  import PACK_SUITABLE_FOR_STATUS from '../../enums/packSuitableForStatus'

  export default {
    data() {
      return {

        // for update
        isEdit: false,
        packLoaded: null,
        packId: null,

        //normal
        packs: [],
        name: '',
        description: '',
        suitableFor: [],
        tags: [],
        isLoading: false,
        ages: [],
      }
    },
    created() {
      try {
        this.ages = PACK_SUITABLE_FOR_STATUS
        if (this.$route.params.id) {
          this.isEdit = true
          this.packId = this.$route.params.id
          this.loadPackById(this.packId)
        }
      } catch (err) {
        displayHelper.displayError(this, 'Oops, there was an error: ' + err.message)
      }
    },
    methods: {
      loadPackById(packId) {
        this.isLoading = true
        var parent = this
        packService.getPackById(packId)
          .then((pack) => {
            this.packLoaded = pack

            this.name = this.packLoaded.name
            this.description = this.packLoaded.description
            this.suitableFor = this.packLoaded.suitableFor
            this.tags = this.packLoaded.tags

            this.isLoading = false
          })
          .catch((err) => {
            displayHelper.displayError(parent, 'Oops, there was an error: ' + err.message)
            this.isLoading = false
          })
      },
      async createPack() {
        this.isLoading = true
        console.log('new pack')
        const pack = {
          name: this.name,
          description: this.description,
          createdDate: dateHelper.getFormattedStringDateNow(),
          suitableFor: this.suitableFor,
          tags: this.tags
        }

        const creationPackResult = await packService.createPack(pack)
        this.isLoading = false
        if (creationPackResult.isSuccess) {
          const createdPack = creationPackResult.data
          this.packs.push(createdPack)
          displayHelper.displaySuccess(this, 'Pack has successfully been created')
          this.$router.back()

        } else {
          displayHelper.displayError(this, 'Oops, there was an error: ' + creationPackResult.errors)
        }
      },
      async updatePack() {
        this.isLoading = true
        var parent = this
        const pack = {
          packId: this.packId,
          name: this.name,
          description: this.description,
          suitableFor: this.suitableFor,
          tags: this.tags
        }

        const updatePackResult = await packService.updatePack(pack)
        this.isLoading = false
        if (updatePackResult.isSuccess) {
          const updatedPack = updatePackResult.data
          // TODO: mettre à jour et pas push les packs
          this.packs.push(updatedPack)
          displayHelper.displaySuccess(this, 'Pack has successfully been updated')
          this.$router.back()

        } else {
          displayHelper.displayError(parent, 'Oops, there was an error: ' + updatePackResult.errors)
        }
      },
      cancel() {
        this.$router.go(-1)
      },
    }
  }
</script>

<style scoped>
    .pack-form .is-horizontal .field-label {
        flex-grow: 0;
    }

    .pack-form label {
        margin-bottom: 0;
        /* width: 50% !important; */
    }

    .pack-form .column .field {
        align-items: center;
    }

    .btn-margin {
        margin-left: 10px;
        margin-right: 10px;
    }
</style>
